<script>
    import { mapState, mapActions, mapMutations } from 'vuex';
    import debounce from 'lodash/debounce';
    import C1Paginator from '@/components/C1Components/C1Paginator';
    import C1Alert from '@/components/C1Components/C1Alert';
    import C1PaginatorShowingResults from '@/components/C1Components/C1PaginatorShowingResults';
    import C1Spinner from '@/components/C1Components/C1Spinner';
    import Cookie from '@/services/cookie';

    import FilterTagsList from '../Filters/FilterTagsList';
    import SearchResultSidebar from '../Filters/SearchResultSidebar';
    import SearchBar from '../SearchBar';
    import SearchBarMobile from '../SearchBarMobile';
    import SearchResultLoop from '../SearchResultLoop';
    import SearchResultMap from '../SearchResultMap';
    import SaveSearch from '../Actions/SaveSearch';
    import SortSearch from '../Actions/SortSearch';
    import SearchViewBtn from '../Actions/SearchViewBtn';

    export default {
        components: {
            C1Alert,
            C1Paginator,
            C1PaginatorShowingResults,
            C1Spinner,
            SearchBar,
            SearchBarMobile,
            FilterTagsList,
            SearchResultSidebar,
            SearchResultLoop,
            SearchResultMap,
            SaveSearch,
            SortSearch,
            SearchViewBtn,
        },

        data() {
            return {
                mapView: false,
                paginator: {
                    current_page: 1,
                    per_page: 20,
                },
            };
        },

        computed: {
            ...mapState({
                $_search: state => state.search,
                $_searchResults: state => state.search.searchPayload.search_results,
                $_jobsSearchFilters: state =>
                    state.search.searchPayload.search_filters,
                $_jobsCount: state =>
                    state.search.searchPayload.search_results
                        ? state.search.searchPayload.search_results.job_count
                        : 0,
                $_mapViewJobsCount: state => state.search.mapView.total,
                $_jobs: state => state.search.searchPayload.search_results.jobs,
            }),

            isMapEnabled() {
                return (
                    window?.afConfig?.jobs_list_map_enabled?.toLowerCase() === 'yes'
                );
            },
        },

        methods: {
            ...mapActions('search', {
                $_searchJobsByFilter: 'searchJobsByFilter',
            }),

            ...mapMutations('search', {
                $_SET_LOADING_JOBS: 'SET_LOADING_JOBS',
                $_SET_OBJECT: 'SET_OBJECT',
                $_SET_SEARCH_FILTERS: 'SET_SEARCH_FILTERS',
            }),

            changePage(page) {
                this.$_SET_SEARCH_FILTERS({
                    key: 'page',
                    value: page,
                    preventSearch: false,
                });
                window.scrollTo({
                    top: 100,
                    left: 100,
                    behavior: 'smooth',
                });
            },

            onSort() {
                this.searchByFilter();
            },

            onSearch(redirect) {
                this.searchByFilter(redirect);
            },

            toggleMapView() {
                if (!this.isMapEnabled) {
                    return;
                }

                this.$_SET_LOADING_JOBS(true);

                this.mapView = !this.mapView;

                this.changePage(1);
            },

            // eslint-disable-next-line
            searchByFilter: debounce(async function(redirect = true) {
                this.$_SET_LOADING_JOBS(true);

                const searchFilter = { ...this.$_jobsSearchFilters };
                searchFilter.facet = 1;

                if (this.mapView) {
                    searchFilter.resultsPerPage = -1;
                } else {
                    searchFilter.resultsPerPage = this.paginator.per_page;
                }

                this.$_searchJobsByFilter(searchFilter)
                    .then(response => {
                        const searchPayload = response;
                        this.$_SET_OBJECT({
                            key: 'searchPayload',
                            value: searchPayload,
                        });

                        let path;
                        if (response.meta.canonical_url) {
                            path = `/${response.meta.canonical_url}/`;
                        } else {
                            path = '/';
                        }

                        Cookie.setJobFilter(path);
                        if (this.$route.path !== path) {
                            this.$router.push(path);
                        }

                        // window.location.href = `/${response.meta.canonical_url}/`;
                    })
                    .catch(e => {
                        if (
                            e.response.status === 404 ||
                            e.response.status === 422
                        ) {
                            const url = `${this.$_currentAppUrl}/not-found/`;
                            window.location.href = url;
                        }
                    })
                    .finally(() => {
                        this.$_SET_LOADING_JOBS(false);
                    });
            }, 350),

            // showTaxonomyCount() {
            //     return (window.afConfig?.hide_taxonomy_count === 'Yes') ? false : true;
            // },
        },

        watch: {
            // eslint-disable-next-line
            '$_search.emitSearchFilterCount': function(newValue) {
                this.searchByFilter();
            },
        },
    };
</script>
